export default __webpack_public_path__ + "frame_logo.901e0ca3.svg";